import { useEffect } from "react";
import LabChrome from "@/components/LabChrome";
import { api } from "@/lib/api";

export default function WindowsLab() {
  useEffect(() => { api.post("/portal/labs/windows/touch").catch(() => {}); }, []);
  return (
    <LabChrome title="Windows Server Lab" subtitle="HMG VDI Simulator — Windows Server 2025" accent="#3b82f6" contentClassName="flex">
      <iframe
        title="HMG VDI Simulator — Windows System Administration"
        src="/vdi/index.html"
        className="w-full h-full border-0 block"
        data-testid="vdi-iframe"
      />
    </LabChrome>
  );
}
